<ion-app>
  <div class="c-dev-strip" *ngIf="isNotProd"><div>DEV</div></div>
  <ion-router-outlet></ion-router-outlet>
</ion-app>

<app-toast-container></app-toast-container>
